import React, { useMemo } from 'react';
import { formatCurrency } from '@sailpoint/bva-core';

function formatPercentage(value) {
    if (value === null || value === 0) return "-";
    return `${value}%`;
}

export default function DetailedTable({ results }) {
    const displayRows = useMemo(() => {
        if (!results || !results.savingsBreakdown) return [];
        let tempSavingsBreakdown = [...results.savingsBreakdown];
        let totalRow;
        const benefitsOnly = tempSavingsBreakdown.filter(row => {
            if (row.benefit === 'Total') {
                totalRow = row;
                return false;
            }
            return row.total > 0;
        });
        benefitsOnly.sort((a, b) => b.total - a.total);
        const rows = [...benefitsOnly];
        if (totalRow) rows.push(totalRow);
        return rows;
    }, [results]);

    if (!results || !results.savingsBreakdown) {
        return (
            <div className="bg-white p-4 rounded-lg shadow mt-8">
                <p className="text-center text-gray-500">Detailed table will appear here after calculation.</p>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow mt-8">
            <h3 className="text-xl text-gray-700 p-4 text-center">Detailed Savings Breakdown</h3>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Benefit</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Year 1</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Year 2</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Year 3</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Year 4</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Year 5</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">% Improvement</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {displayRows.map(row => (
                            <tr key={row.benefit} className={row.benefit === 'Total' ? 'font-semibold bg-gray-50' : ''}>
                                <td className="px-4 py-3  text-left whitespace-nowrap text-sm text-gray-800 font-medium">{row.benefit}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800 text-right">{formatCurrency(row.y1, results.currencySymbol)}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800 text-right">{formatCurrency(row.y2, results.currencySymbol)}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800 text-right">{formatCurrency(row.y3, results.currencySymbol)}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800 text-right">{formatCurrency(row.y4, results.currencySymbol)}</td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800 text-right">{formatCurrency(row.y5, results.currencySymbol)}</td>
                                <td className={`px-4 py-3 whitespace-nowrap text-sm text-gray-800 text-right ${row.benefit === 'Total' ? 'font-bold' : ''}`}>
                                    {formatCurrency(row.total, results.currencySymbol)}
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800 text-right">
                                    {row.benefit !== 'Total' ? formatPercentage(row.percentageImprovement) : ''}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
